import ol from 'openlayers';
import Config from 'src/config.json';
import moment from 'moment';
import 'moment-timezone';
import StartFlag from 'src/img/Start Icon.png';
import EndFlag from 'src/img/End Icon.png'
import CorneringIcon from 'src/img/Cornering Icon.png'
import BrakingIcon from 'src/img/Braking Icon.png'
import AccelIcon from 'src/img/Accel Icon.png'

// イベントがある地点のマーカーを作成する
function createEventMarker(events) {
  // マーカーのイベント情報を作成
  function createEvent(point) {

    var gForce_min = 0.35;
    var gForce_max = 0.50;
    let eventDatas = [];
    let gData = 0;

    if("eventType" in point){
      // Configのイベントの中から該当するイベントを取得する
      for (let event in Config.MAP.EVENTS) {
        // Configからプロパティ名(エイリアス)を取り出し
        let eventAlias = Config.MAP.EVENTS[event].EVENTNUM;
        // データにエイリアスが存在するか
        if (eventAlias === point["eventType"]) {
          // 安全装置のイベントか
          if (eventAlias === "act") {
            continue
          }
          if ("gforce" in point){
            gData = parseFloat(point["gforce"])
          }

          // 以前の処理
          // eventDatas.push({
          //   "title": event,
          //   "name": Config.MAP.EVENTS[event].NAME,
          //   "text": Config.MAP.EVENTS[event].TEXT,
          //   "color": Config.MAP.EVENTS[event].COLOR,
          //   "data": gData,
          //   "time": point["dtTime"]
          // });

          // 閾値を超えるイベントのみカウントするように
          if (point["eventType"] === "3"){
            gForce_min = 0.40;
            gForce_max = 0.60;
          }
          if(gForce_min <= gData && gData <= gForce_max){
            eventDatas.push({
              "title": event,
              "name": Config.MAP.EVENTS[event].NAME,
              "text": Config.MAP.EVENTS[event].TEXT,
              "color": Config.MAP.EVENTS[event].COLOR,
              "data": gData,
              "time": point["dtTime"]
            });
          }
        }
      }
    }
    return eventDatas;
  }

  // マーカーの位置情報を保持
  function createPoint(lat, lon, eventDatas, time) {
    // シンガポールの時間に変換
    let momentTime = moment.utc(time);
    let convertedTime = momentTime.tz("Asia/Jakarta").format("YYYY/MM/DD HH:mm:ss");
    return new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat([lon, lat])),
      data: eventDatas,
      time: convertedTime,
    });
  }

    // マーカーを画像で設定する
  function createImage(imgSrc) {
    return new ol.style.Icon({
      src: imgSrc
    });
  }
  

  // 格納用マーカー配列
  let eventMarkers = [];
  // それぞれのTripの情報を取得して、それぞれ格納
  events.forEach(function (point, index) {

    // データから緯度経度を取得
    let lat = parseFloat(point.lat);
    let lon = parseFloat(point.lon);

    // 時間を取得
    let time = point.tm;

    // 不正な緯度・経度の場合は作らない
    if (checkLatRange(lat) || checkLonRange(lon)) {
      return;
    }

    // イベントを取得
    let eventDatas = createEvent(point);
    
    // イベントが無い場合は飛ばす
    if (eventDatas.length === 0) {
      return;
    }

    // デフォルトのスタイル
    let opt = {
      strokeColor: 'black',
      color: 'blue',
      textFill: 'black',
      text: ''
    };

    // イベントのスタイルを取り出す
    for (let event in eventDatas) {
      opt.text = eventDatas[event].text;
      opt.color = eventDatas[event].color;
    }

    // 地図に使用するアイコンの決定
    let icon = AccelIcon;
    // console.log(opt.text)
    if(opt.text === 'HB'){
      icon = BrakingIcon
    }else if(opt.text === 'CR'){
      icon = CorneringIcon
    }
    
    // // 終了イベントしかなければマーカーは作らない
    // if (opt.text === '') {
    //   return;
    // }

    let marker = createPoint(lat, lon, eventDatas, time);

    // マーカー情報を格納する
    marker.setStyle(new ol.style.Style({
      image: createImage(icon)
      // text: createText(opt)
    }));

    // 完成したマーカーを格納
    eventMarkers.push(marker);
  });

  return eventMarkers;
}

// 走行開始・終了地点のマーカーを作成する
function createStartEndMarker(tripDatas) {

  // 走行開始・終了地点の緯度経度を取得
  function getStartEndCoord(validationDatas) {

    // 各緯度経度を取得
    let coord = {
      start: {
        lat: parseFloat(validationDatas[0].lat),
        lon: parseFloat(validationDatas[0].lon)
      },
      end: {
        lat: parseFloat(validationDatas[validationDatas.length - 1].lat),
        lon: parseFloat(validationDatas[validationDatas.length - 1].lon)
      }
    }

    return coord;
  }

  // マーカーの位置情報を保持
  function createPoint(point) {
    return new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat([point.lon, point.lat])),
      name: "StartEnd"
    });
  }

  // マーカーを画像で設定する
  function createImage(imgSrc) {
    return new ol.style.Icon({
      src: imgSrc
    });
  }
  
  // 正常な緯度経度のみの配列を生成
  let validationDatas = tripDatas.filter(function (point) {
    if (!checkLatRange(parseFloat(point.lat)) && !checkLonRange(parseFloat(point.lon))) {
      return true;
    }
    return false;
  });

  // 正常な緯度経度データが無ければ空配列を返す
  if (validationDatas.length === 0) {
    return [];
  }

  // 走行開始・終了地点の緯度経度を取得
  let coord = getStartEndCoord(validationDatas);
  let startPoint = createPoint(coord.start)
  let endPoint = createPoint(coord.end)

  // マーカー情報を格納する
  startPoint.setStyle(new ol.style.Style({
    image: createImage(StartFlag),
    // text: createText("START")
  }));

  endPoint.setStyle(new ol.style.Style({
    image: createImage(EndFlag),
    // text: createText("END")
  }));

  // 返却値生成
  let startEndMarker = [startPoint, endPoint];

  return startEndMarker;
}

function createEmphasisMarker(coord) {

  // マーカーの位置情報を保持
  function createPoint(coord) {
    return new ol.Feature({
      geometry: new ol.geom.Point(ol.proj.fromLonLat([coord.lon, coord.lat])),
      name: "StartEnd"
    });
  }

  // マーカーを画像で設定する
  function createImage(imgSrc) {
    return new ol.style.RegularShape({
      fill: new ol.style.Fill({
        color: "aqua"
      }),
      stroke: new ol.style.Stroke({
        color: "black",
        width: 2
      }),
      points: 5,
      radius: 10,
      radius2: 4,
      angle: 0,
    })
  }

  let marker = createPoint(coord);

  // マーカー情報を格納する
  marker.setStyle(new ol.style.Style({
    image: createImage(StartFlag),
  }));

  return marker;
}

// 走行ルートデータを作成する
function createRoute(tripDatas) {

  // 緯度経度正常ルート
  let correctRoutes = {
    routes: []
  };
  // 緯度経度不正ルート
  let incorrectRoutes = {
    routes: []
  };

  // 正常・不正ルート格納用
  let route = [];
  // 不正な緯度経度フラグ
  let isIncorrect = false;
  // 不正ルートの開始地点
  let lastCorrectCoord = null;

  // 正常ルート,不正ルートを作成する
  tripDatas.forEach(function (point, index) {

    // 緯度経度確認
    if (checkLatRange(parseFloat(point.lat)) || checkLonRange(parseFloat(point.lon))) {
      isIncorrect = true;
    } else {
      isIncorrect = false;
    }
    // 不正な緯度経度のデータか
    if (isIncorrect) {
      // 正常ルートが格納されているか
      if (route.length !== 0) {
        // 正常ルートを確定
        correctRoutes.routes.push(route);
        // 不正値の1つ前の座標を取得しておく
        lastCorrectCoord = route[route.length - 1];
        // 正常ルートをリセット
        route = [];
      }
    } else {
      // 不正ルートの開始地点が存在するか
      if (lastCorrectCoord) {
        // 不正ルートを確定
        route.push(lastCorrectCoord);
        route.push(ol.proj.fromLonLat([parseFloat(point.lon), parseFloat(point.lat)]));
        incorrectRoutes.routes.push(route);
        // 不正ルートをリセット
        route = [];
        lastCorrectCoord = null;
      } else {
        // 正常値を格納する
        route.push(ol.proj.fromLonLat([parseFloat(point.lon), parseFloat(point.lat)]))
      }
    }
  });

  // ループ後に正常ルートが格納されているか
  if (route.length !== 0) {
    correctRoutes.routes.push(route);
  }

  // 返却値を作成
  let routes = {
    correctRoutes: correctRoutes,
    incorrectRoutes: incorrectRoutes,
  }

  return routes
}

// 緯度チェック
function checkLatRange(val) {
  return val < -90 || 90 < val;
}
// 経度チェック
function checkLonRange(val) {
  return val < -180 || 180 < val;
}

//  TripのデータをMap用のデータに変換
function convertTripData(tripDatas, events) {
  let coordinates = [];
  let markers = [];

  // 経路を作成
   tripDatas.forEach(function (point, index) {
    coordinates.push({
      lat: parseFloat(point.lat),
      lon: parseFloat(point.lon)
    });
  });

  // イベントマーカーを作成・イベント情報のみからデータを作成するように
  let eventMarkers = createEventMarker(events);

  markers = markers.concat(eventMarkers);

  // 走行開始・終了地点マーカーを作成
  let startEndMarker = createStartEndMarker(tripDatas);
  markers = markers.concat(startEndMarker);

  let routes = createRoute(tripDatas);

  // ルート情報とマーカー情報を返却
  return {
    correctRoutes: routes.correctRoutes,
    incorrectRoutes: routes.incorrectRoutes,
    markers: markers
  };
}

// データ取得完了時のレスポンスを受け取った時の処理
function response(res, err) {

  if (err) {
    // TODO 通信エラー発生時の対応の仕方が未定
    console.log(err);
    throw err;
  }

  let source = this.correctRouteLayer.getSource();
  // 作成されたルート情報を表示するために、表示位置、縮尺を調整
  source.on('change', function () {
    if (source.getState() === 'ready') {
      if (isFinite(source.getExtent()[0])) {
        this.map.getView().fit(source.getExtent());
      }
    }
  }.bind(this));

  this.tripDatas = [];
  this.events = [];

  if (res.length !== 0) {
    this.tripDatas = res[0]
    this.events = res[1]
  }

  // 取得したTripのデータを地図用データに変換
  let mapData = convertTripData(this.tripDatas, this.events);

  // 地図用データをそれぞれのレイヤーに格納
  this.markerLayer.getSource().addFeatures(mapData.markers);

  let _this = this;

  // 正常ルートを描画
  mapData.correctRoutes.routes.forEach(function (route, index) {
    _this.correctRouteLayer.getSource().addFeatures([
      new ol.Feature({
        geometry: new ol.geom.LineString(route),
        name: 'CorrectLine',
      })
    ]);
  })
  // 不正ルートを描画
  mapData.incorrectRoutes.routes.forEach(function (route, index) {
    _this.incorrectRouteLayer.getSource().addFeatures([
      new ol.Feature({
        geometry: new ol.geom.LineString(route),
        name: 'IncorrectLine',
      })
    ]);
  })
}

// ルート用のレイヤーを作成する
function createRouteLayer(width, color, lineDash) {
  // ルートスタイル
  let routeStyle = new ol.style.Style({
    stroke:
    new ol.style.Stroke({
      width: width,
      color: color,
      lineDash: lineDash
    }),
  })
  return new ol.layer.Vector({
    source: new ol.source.Vector(),
    style: routeStyle,
  })
}

// Mapを作成する
function createMap(target, layers, overlays) {
  return new ol.Map({
    target: target,
    controls: ol.control.defaults({
    }).extend([
      new ol.control.ScaleLine()
    ]),
    layers: layers,
    view: new ol.View({
      center: ol.proj.fromLonLat([Config.MAP['DEFAULT_LON'], Config.MAP['DEFAULT_LAT']]),
      zoom: 11,
      minZoom: 10,
      maxZoom: 17
    }),
    overlays: overlays
  });
}

// Mapに表示するレイヤー等を作成する
function TripMapDrawing(mapId, sub, startTime, getTripMap) {
  this.mapId = mapId;
  this.sub = sub;
  this.startTime = startTime;

  // オーバレイをセットする要素
  let container = document.getElementById('popup');
  let content = document.getElementById('popup-content');
  let closer = document.getElementById('popup-closer');

  // ポップアップ表示用オーバレイ
  let overlay = new ol.Overlay({
    element: container,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    }
  });

  // ポップアップの×ボタンクリック
  closer.onclick = function () {
    overlay.setPosition(undefined);
    closer.blur();
    mapClick.getFeatures().clear();
    return false;
  };

  // レスポンスデータ保持用
  this.tripDatas = {};

  // 地図用のレイヤー作成
  this.mapLayer = new ol.layer.Tile({
    source: new ol.source.OSM()
  });

  // 正常な緯度経度のレイヤー作成
  this.correctRouteLayer = createRouteLayer(5, 'royalblue', []);

  // 不正な緯度経度のレイヤー作成
  this.incorrectRouteLayer = createRouteLayer(5, 'royalblue', [5, 10]);

  // マーカー用のレイヤー作成
  this.markerLayer = new ol.layer.Vector({
    source: new ol.source.Vector(),
  });

  // 地図連携用のレイヤー作成
  this.emphasisLayer = new ol.layer.Vector({
    source: new ol.source.Vector(),
  });

  // レイヤー配列
  let layers = []
  layers.push(this.mapLayer);
  layers.push(this.correctRouteLayer);
  layers.push(this.incorrectRouteLayer);
  layers.push(this.markerLayer);
  layers.push(this.emphasisLayer);

  // オーバレイ配列
  let overlays = []
  overlays.push(overlay);

  // 地図を作成
  this.map = createMap(this.mapId, layers, overlays)

  // 地図クリック時アクション
  let mapClick = new ol.interaction.Select(
    {
      condition: ol.events.condition.click,
      layers: [this.markerLayer, this.correctRouteLayer]
    }
  );

  // 地図にアクション設定を追加
  this.map.addInteraction(mapClick);

  // 地図をクリックした時のアクション
  mapClick.on('select', function (e) {
    let selected = e.selected;
    if (selected.length !== 0) {
      // 種類を取得
      let name = selected[0].get('name');
      // 種類によって処理を分ける
      if (name === 'StartEnd') {
        // 走行開始・終了地点のマーカーの場合は何もしない
        return;
      } else if (name === 'CorrectLine') {
        // interactionの上書き描画を無効にする
        mapClick.setMap(null);
        return;
      } else {
        // イベントマーカーの場合は格納されている情報をポップアップ表示する
        let eventDatas = selected[0].get('data');
        let time = dateConvert(selected[0].get('data')[0]["time"]);
        let geometry = selected[0].get('geometry').getCoordinates();
        content.innerHTML = createMarkerPopupHtml(eventDatas, time);
        overlay.setPosition(geometry);
        return;
      }
    }
    overlay.setPosition(undefined);
    closer.blur();
  });

  // グラフ連携用関数
  this.setEmphasisMarker = function (coord) {
    // 緯度経度情報があるか
    if (coord) {
      // ある場合は既存のマーカーを消して再度作成&描画
      let marker = createEmphasisMarker(coord);
      this.emphasisLayer.getSource().clear();
      this.emphasisLayer.getSource().addFeature(marker);
    } else {
      // 無い場合はマーカーを消す
      this.emphasisLayer.getSource().clear();
    }
  }

  // Tripデータ取得
  // レスポンスをresponse関数の引数とする
  getTripMap(sub, startTime, response.bind(this));
}

// 文字列で受け取ってきた日付の表示変換を行う。
function dateConvert(time){
  // UTC時刻をインドネシア時刻(UTC+7)に変換
  let dates = new Date(time.substring(0, 4), time.substring(4, 6) - 1,
  time.substring(6, 8), time.substring(8, 10), time.substring(10, 12), time.substring(12, 14))
  dates.setHours(dates.getHours() + 7)

  // データの0埋め
  let month = ('0' +  (dates.getMonth() + 1)).slice(-2)
  let day = ('0' + dates.getDate()).slice(-2)
  let hour = ('0' + dates.getHours()).slice(-2)
  let min = ('0' + dates.getMinutes()).slice(-2)
  let sec = ('0' + dates.getSeconds()).slice(-2)

  // 文字列として返却
  let date = day + "/" + month + "/" + dates.getFullYear() + " " + hour + ":" + min + ":" + sec
  return date
}

// マーカークリック時、オーバレイに表示するHTMLを作成する
function createMarkerPopupHtml(eventDatas, time) {
  let html = convertLiTag(eventDatas);
  return '<ul class="list-group col-xs-12 popup-ul"><li class="list-group-item col-xs-12 popup-text">' + time + '</li></ul>'
    + '<ul class="list-group col-xs-12 popup-ul">' + html + '</ul>';
}

// イベント情報を<li>タグに変換する
function convertLiTag(eventDatas) {

  let html = ''

  for (let event in eventDatas) {
    // イベントごとの値を取得
    let eventName = eventDatas[event].name;
    let valueName = '';
    let value = '';

    if("data" in eventDatas[event]){
      valueName ='gForce'
      value = eventDatas[event].data
    }

    value = truncationValue(value, 6)

    html += '<li class="list-group-item col-xs-12 popup-text">' + eventName + '</li>';
    // 安全装置イベントじゃない時は各値を表示
    if (valueName !== '') {
      html += '<li class="list-group-item col-xs-12 popup-text">' + valueName + ' : ' + value + '</li>';
    }

  }

  return html;
}

// 指定した小数点の位以下を切り捨てる
function truncationValue(value, digit) {
  return Math.floor(value * Math.pow(10, digit)) / Math.pow(10, digit);
}

export default TripMapDrawing;


// WEBPACK FOOTER //
// ./src/component/TripReportDetail/TripMapDrawing.js